import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'happy-list',
    templateUrl: './happy-list.component.html',
    styleUrls: ['./happy-list.component.css']
})
export class HappyListComponent implements OnInit {

    @Input() items$: Observable<any>;
    @Input() config: ListConfig;
    @Input() templateRef: ElementRef;

    searchChanged$ = new Subject<string>();
    processedItems$: Observable<Array<{ matches: boolean }>>;
    @Output() onItemClick = new EventEmitter();

    constructor() {
    }

    ngOnInit() {

        if (!(this.config && this.config instanceof ListConfig)) {
            throw Error('Missing input property ListConfig');
        }

        this.processedItems$ = this.items$
            .flatMap(placeholders => this.searchChanged$
                .map(search => this.sortPlaceholders(placeholders, search))
                .startWith(this.sortPlaceholders(placeholders, ''))
            )
            .shareReplay();
    }

    private sortPlaceholders(items: Array<any>, search: string): Array<{ matches: boolean }> {
        return items
            .map(placeholder => ({ ...placeholder, matches: this.config.matcher(placeholder, search) }))
            .sort((a, b) => {
                if (a.matches !== b.matches) {
                    return a.matches ? -1 : 1;
                }

                return this.config.comparator(a, b);
            });
    }

    onSearchChange(search: string) {
        this.searchChanged$.next(search);
    }

    onItemClicked(event: MouseEvent, item) {
        this.onItemClick.emit({ event, item });
    }
}

export class ListConfig {

    constructor(public readonly matcher: (item, search) => boolean,
                public readonly comparator: (a, b) => number) {
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-list/happy-list.component.ts